// extracted by mini-css-extract-plugin
export var animationContainer = "_gq-0";
export var asteriskIcon = "_gq-8";
export var conversationLeftSection = "_gq-4";
export var conversationListItem = "_gq-3";
export var conversationMiddleSection = "_gq-5";
export var conversationRightSection = "_gq-6";
export var detailsContent = "_gq-1";
export var listContainer = "_gq-7";
export var modalContent = "_gq-2";